// packages/eden-table/src/components/Density/Context.jsx
import { createContext } from "react";
var DensityContext = createContext();
var Context_default = DensityContext;
export {
  Context_default as default
};
